import React, {
  useEffect,
  useState
} from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout } from 'src/actions/accountActions';
import authService from 'src/services/authService';
import { hasWorkspaceAccess } from 'src/utils/navigation';

const NO_WORKSPACES_WARNING_KEY = 'auth-warning:no-workspaces';

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        const user = await authService.loginInWithToken();
        if (hasWorkspaceAccess(user)) {
          sessionStorage.removeItem(NO_WORKSPACES_WARNING_KEY);
          await dispatch(setUserData(user));
        } else {
          sessionStorage.setItem(NO_WORKSPACES_WARNING_KEY, '1');
          await dispatch(logout());
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  useEffect(() => {
    let isActive = true;

    const refreshUserSession = async () => {
      if (!authService.isAuthenticated()) {
        return;
      }

      try {
        const user = await authService.loginInWithToken();
        if (isActive) {
          if (hasWorkspaceAccess(user)) {
            sessionStorage.removeItem(NO_WORKSPACES_WARNING_KEY);
            await dispatch(setUserData(user));
          } else {
            sessionStorage.setItem(NO_WORKSPACES_WARNING_KEY, '1');
            await dispatch(logout());
          }
        }
      } catch (error) {
        const shouldLogout = error?.response?.status === 401;
        if (isActive && shouldLogout) {
          authService.logout();
          dispatch(logout());
        }
      }
    };

    const handleFocus = () => {
      refreshUserSession();
    };

    const intervalId = setInterval(refreshUserSession, 60000);
    window.addEventListener('focus', handleFocus);

    return () => {
      isActive = false;
      clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
    };
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
